import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "./layouts/MainLayout";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Categories from "./pages/Categories";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Checkout from "./pages/Checkout";
import ProductDetails from "./pages/ProductDetails";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import MyOrders from "./pages/MyOrders";
import ProtectedRoute from "./components/ProtectedRoute";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import ShippingPolicy from "./pages/ShippingPolicy";
import ReturnPolicy from "./pages/ReturnPolicy";
import TrackOrder from "./pages/TrackOrder";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import Addresses from "./pages/Addresses";
import BackToTop from "./components/BackToTop";
import AgeVerificationPopup from "./components/AgeVerificationPopup";
import CookieConsent from "./components/CookieConsent";
import ChangePassword from "./pages/ChangePassword";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProducts from "./pages/AdminProducts";
import AddProduct from "./pages/AddProduct";
import AdminUsers from "./pages/AdminUsers";
import AdminOrders from "./pages/AdminOrders";
import WebsiteManagement from "./pages/WebsiteManagement";
import AdminHeroBanner from "./pages/AdminHeroBanner";
import AdminAnnouncement from "./pages/AdminAnnouncement";
import AdminFlashSale from "./pages/AdminFlashSale";
import AdminCategories from "./pages/AdminCategories";
import AdminNewArrivals from "./pages/AdminNewArrivals";
import AdminFeaturedProducts from "./pages/AdminFeaturedProducts";
import AdminFooter from "./pages/AdminFooter";
import OrderSuccess from "./pages/OrderSuccess";
function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Pages with Header/Navbar */}
        <Route element={<MainLayout />}>

          <Route path="/" element={<Home />} /> 
<Route path="/about" element={<About />} />

<Route path="/faq" element={<FAQ />} />
<Route
path="/admin/users"
element={<AdminUsers/>}
/>

<Route
path="/admin/orders"
element={<AdminOrders/>}
/>
<Route
    path="/admin/footer"
    element={<AdminFooter />}
/>
<Route
    path="/admin/hero-banner"
    element={<AdminHeroBanner />}
/>
<Route
  path="/admin/website"
  element={<WebsiteManagement />}
/>
<Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route
 path="/admin/add-product"
 element={<AddProduct />}
/>
<Route path="/terms" element={<TermsConditions />} />
<Route
  path="/admin/products"
  element={<AdminProducts />}
/>
<Route path="/shipping-policy" element={<ShippingPolicy />} />
<Route
    path="/admin/announcement"
    element={<AdminAnnouncement />}
/>
<Route path="/return-policy" element={<ReturnPolicy />} />

<Route path="/track-order" element={<TrackOrder />} />
<Route path="/forgot-password" element={<ForgotPassword />} />
<Route
    path="/admin/flash-sale"
    element={<AdminFlashSale />}
/>

<Route path="/admin/categories" element={<AdminCategories />} />
<Route
    path="/admin/new-arrivals"
    element={<AdminNewArrivals />}
/>
<Route
    path="/admin/featured-products"
    element={<AdminFeaturedProducts />}
/>




<Route
  path="/admin"
  element={<AdminDashboard />}
/>

<Route
  path="/admin/dashboard"
  element={<AdminDashboard />}
/>
<Route
  path="/change-password"
  element={
    <ProtectedRoute>
      <ChangePassword />
    </ProtectedRoute>
  }
/>
<Route
    path="/reset-password/:token"
    element={<ResetPassword />}
/>
<Route
  path="/profile"
  element={
    <ProtectedRoute>
      <Profile />
    </ProtectedRoute>
  }
/>
<Route
path="/order-success"
element={<OrderSuccess/>}
/>
<Route
  path="/edit-profile"
  element={
    <ProtectedRoute>
      <EditProfile />
    </ProtectedRoute>
  }
/>

<Route
  path="/addresses"
  element={
    <ProtectedRoute>
      <Addresses />
    </ProtectedRoute>
  }
/>
          <Route path="/shop" element={<Shop />} />

          <Route path="/categories" element={<Categories />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/product/:id" element={<ProductDetails />} />

          <Route
            path="/cart"
            element={
              <ProtectedRoute>
                <Cart />
              </ProtectedRoute>
            }
          />

          <Route
            path="/wishlist"
            element={
              <ProtectedRoute>
                <Wishlist />
              </ProtectedRoute>
            }
          />

          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />

        </Route>
<Route
  path="/my-orders"
  element={
    <ProtectedRoute>
      <MyOrders />
    </ProtectedRoute>
  }
/>
        {/* Pages WITHOUT Header/Navbar */}
        <Route path="/login" element={<Login />} />

        <Route path="/register" element={<Register />} />

        <Route path="*" element={<NotFound />} />

      </Routes>
        <AgeVerificationPopup />
  <CookieConsent />

        <BackToTop />

    </BrowserRouter>
  );
}

export default App;